/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';
import {
  environment
} from '../../../environments/environment';
import {
  HttpClient,
 } from '@angular/common/http';
import { SystemService } from '../../service/system.service';

@Injectable()
export class wicService {
  private dataModelUrl = '';


  constructor(private http: HttpClient) {
    let systemService = new SystemService();
    if (environment && environment.properties) {
      this.dataModelUrl = systemService.getDataModelUrl();
    }
  }

  getWicData() {
    const url = `${this.dataModelUrl}wic_dashboard?sort={"_id":-1}&pagesize=1&filter={}`;
    return this.http.get(url)
      .toPromise()
      .then(response => {

        if (response && response[0]) {
          return response;
        }
        return [];
      })
      .catch(reason => {
        console.error(reason);
      })
  }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/wic/wic.service.ts